import xss from 'xss';

const baseWhiteList = {
    u: [],
    br: [],
    b: [],
    blockquote: [],
    s: [],
    i: [],
    ol: ['style'],
    ul: ['style'],
    li: ['class'],
    p: ['style'],
    sub: [],
    sup: [],
    div: ['style'],
    em: [],
    strong: [],
    span: ['style'],
    h1: ['style'],
    h2: ['style'],
    h3: ['style'],
    a: ['style', 'href', 'target'],
    video: ['controls', 'style'],
    source: ['src', 'type'],
    iframe: ['class', 'allowfullscreen', 'src', 'frameborder']
};

const myxss = new xss.FilterXSS({
    whiteList: baseWhiteList,
    onIgnoreTag: function(tag, html, options) {
        if (tag === 'img') {
            if (html.includes('track.gif')) {
                // this is panelfox's tracking gif.. so just hide this
                return '';
            } else {
                return `[${tag}]`;
            }
        }
    }
});

export const emailXss = new xss.FilterXSS({
    whiteList: {
        ...baseWhiteList,
        // Add img to the whitelist with safe attributes
        img: ['src', 'alt', 'title', 'width', 'height', 'style']
    },
    // Custom URL check to prevent malicious URLs in src attributes
    safeAttrValue: function(tag, name, value, cssFilter) {
        // Additional check for image src attributes
        if (tag === 'img' && name === 'src') {
            // Only allow https protocols for images
            if (/^(https:\/\/|data:image\/)/i.test(value)) {
                return value;
            } else {
                return '';
            }
        }
        // For other attributes, use the default handler
        return xss.safeAttrValue(tag, name, value, cssFilter);
    },
    onIgnoreTag: function(tag, html, options) {
        if (tag === 'img') {
            if (html.includes('track.gif')) {
                // this is panelfox's tracking gif.. so just hide this
                return '';
            }
            // Let img tags be processed by the whitelist now instead of converting them to [img]
            return null;
        }
    }
});

export default myxss;
